<template>
  <div  @click="closeTreeMenu">
    <div class="tree-header">
      <h3 class="tree-header--text">
        <span v-if="title">{{ $t('treeView.title') }}</span>
        <span v-if="favodocs">{{ text.favorite }}</span>
        <span v-if="newdocs">{{ text.newDocsDes }}</span>
        <span v-if="workdocs">{{ text.workBox }}</span>
      </h3>
      <div tabindex="0" @blur="closeMenu">
        <span class="tree-header--button"
              @click="toggleMenu">
        </span>
        <ul class="tree-header--menu"
            v-if="menuVisible">
          <li class="tree-header--item">
            <span @click="showAll() & setActive('allFolders')" :class="{ active: isActive('allFolders') }">
              {{ text.all }}
            </span>
          </li>
          <li class="tree-header--item">
            <span @click="showFavorite() & setActive('favoriteFolders')" :class="{ active: isActive('favoriteFolders') }">
              {{ text.favorite }}
            </span>
          </li>
          <li class="tree-header--item">
            <span @click="showNewDocs() & setActive('lastDocs')" :class="{ active: isActive('lastDocs') }">
             {{ text.newDocs }}
            </span>
          </li>
          <li class="tree-header--item">
            <span @click="showWorkBox() & setActive('workBox')" :class="{ active: isActive('workBox') }">
              {{ text.workBox }}
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div class="tree">
      <ol class="tree__list">
        <div v-if="treeData.length > 0">
          <tree-node v-for="node in treeData" :key="node.id" :node.sync="node" :activeNode="activeNode" @getPath="getPath"></tree-node>
        </div>
      </ol>
    </div>
  </div>
</template>

<script>
import treeNode from './treeNode'

const allFolders = 1
const favoriteFolders = 2
const lastDocs = 3
const workBox = 4

export default {
  data () {
    return {
      menuVisible: false,
      title: true,
      favodocs: false,
      newdocs: false,
      workdocs: false,
      viewMode: 1,
      addData: true,
      activeItem: 'allFolders',
      text: {
        all: this.$t('treeView.allFolder'),
        favorite: this.$t('treeView.favoriteFolder'),
        newDocs: this.$t('treeView.newDocs'),
        workBox: this.$t('treeView.workBox'),
        newDocsDes: this.$t('treeView.newDocsDescription')
      }
    }
  },
  props: {
    activeNode: String,
    node: Object,
    treeData: Array
  },
  methods: {
    getPath (event) {
      // save to local storage
      localStorage.setItem('selectedNodePath', JSON.stringify(event.nodePath))
    },
    closeTreeMenu () {
      window.parent.ContextMenuTree.Hide()
    },
    toggleMenu () {
      if (this.menuVisible) {
        this.closeMenu()
      } else {
        this.showMenu()
      }
    },
    showMenu () {
      this.menuVisible = true
    },
    closeMenu () {
      this.menuVisible = false
    },
    activateNode (node) {
      this.$eventBus.$emit('updateNodes', node)
    },
    showAll () {
      if (this.viewMode === allFolders) {
        return
      }
      this.showChildFavorite(this.treeData.children, false)
      this.title = true
      this.favodocs = false
      this.newdocs = false
      this.workdocs = false
      this.viewMode = allFolders
    },
    showFavorite () {
      if (this.viewMode === favoriteFolders) {
        return
      }
      this.showChildFavorite(this.treeData.children, true)
      this.title = false
      this.favodocs = true
      this.newdocs = false
      this.workdocs = false
      this.viewMode = favoriteFolders
    },
    showNewDocs () {
      if (this.viewMode === lastDocs) {
        return
      }
      this.showChildFavorite(this.treeData.children, false)
      this.title = false
      this.favodocs = false
      this.newdocs = true
      this.workdocs = false
      this.viewMode = lastDocs
      // if (this.treeData.addData !== 7) {
      // }
    },
    showWorkBox () {
      if (this.viewMode === workBox) {
        return
      }
      this.showChildFavorite(this.treeData.children, false)
      this.title = false
      this.favodocs = false
      this.newdocs = false
      this.workdocs = true
      this.viewMode = workBox
    },
    showChildFavorite (children, show) {
      if (!children) {
        return
      }
      for (var i = 0; i < children.length; i++) {
        children[i].favorite = show
        this.showChildFavorite(children[i].children, show)
      }
    },
    isActive (menuItem) {
      return this.activeItem === menuItem
    },
    setActive (menuItem) {
      this.activeItem = menuItem
    }
  },
  components: {
    'treeNode': treeNode
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/treeView/tree.vue